/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useMemo,
  useState,
  useContext,
} from "react";

import {
  Table,
  Container,
  Segment,
  Header,
  Form,
  Input,
  Dropdown,
  Button,
  Icon,
  Label,
} from "semantic-ui-react";

import { useNavigate } from "react-router-dom";

import Alertas from "./Alertas";
import AgregarItemsDb from "../firebase/AgregarItemsDb";
import { auth, db } from "../firebase/firebaseConfig";
import {
  getDocs,
  collection,
  where,
  query,
} from "firebase/firestore";

import { UserContext } from "../context/UserContext";

const AgregarItems = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);
  const navigate = useNavigate();

  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({});

  const [item, setItem] = useState("");
  const [categoria, setCategoria] = useState("");
  const [medida, setMedida] = useState("");
  const [inicial, setInicial] = useState("");
  const [final, setFinal] = useState("");

  const [leer, setLeer] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [medidas, setMedidas] = useState([]);
  const [buscador, setBuscador] = useState("");
  const [flag, setFlag] = useState(false);
  const [guardando, setGuardando] = useState(false);

  // =========================================================
  // HELPERS
  // =========================================================

  const resetAlert = () => {
    cambiarEstadoAlerta(false);
    cambiarAlerta({});
  };

  const showError = (mensaje) => {
    cambiarEstadoAlerta(true);
    cambiarAlerta({
      tipo: "error",
      mensaje,
    });
  };

  const showSuccess = (mensaje) => {
    cambiarEstadoAlerta(true);
    cambiarAlerta({
      tipo: "exito",
      mensaje,
    });
  };

  const norm = (v) =>
    (v || "")
      .toString()
      .trim()
      .toUpperCase();

  const toSearchText = (value) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    if (typeof value === "object") {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    return String(value);
  };

  const volver = () => {
    navigate(-1);
  };

  // =========================================================
  // CARGAR ITEMS
  // =========================================================

  const getData = async () => {
    if (!users?.emp_id) return;

    try {
      const traerit = collection(
        db,
        "items"
      );

      const q = query(
        traerit,
        where(
          "emp_id",
          "==",
          users.emp_id
        )
      );

      const snap = await getDocs(q);

      setLeer(
        snap.docs.map(
          (doc, index) => ({
            ...doc.data(),
            id: doc.id,
            id2: index + 1,
          })
        )
      );
    } catch (error) {
      console.error(
        "Error al cargar items:",
        error
      );

      showError(
        "No fue posible cargar los Items."
      );
    }
  };

  // =========================================================
  // CARGAR CATÁLOGOS
  // =========================================================

  const getCatalogos = async () => {
    if (!users?.emp_id) return;

    try {
      const ref = collection(
        db,
        "catalogosEmpresa"
      );

      const [
        snapCategorias,
        snapMedidas,
      ] = await Promise.all([
        getDocs(
          query(
            ref,
            where(
              "emp_id",
              "==",
              users.emp_id
            ),
            where(
              "catalogoId",
              "==",
              "categoria_protocolo"
            )
          )
        ),

        getDocs(
          query(
            ref,
            where(
              "emp_id",
              "==",
              users.emp_id
            ),
            where(
              "catalogoId",
              "==",
              "medidas"
            )
          )
        ),
      ]);

      const ordenar = (snap) =>
        snap.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
          .filter(
            (doc) =>
              doc.activo === true
          )
          .sort((a, b) => {
            const orden =
              Number(
                a.orden ?? 999
              ) -
              Number(
                b.orden ?? 999
              );

            if (orden !== 0) {
              return orden;
            }

            return String(
              a.text || ""
            ).localeCompare(
              String(
                b.text || ""
              ),
              "es"
            );
          });

      setCategorias(
        ordenar(snapCategorias)
      );

      setMedidas(
        ordenar(snapMedidas)
      );
    } catch (error) {
      console.error(
        "Error al cargar catálogos:",
        error
      );

      showError(
        "No fue posible cargar los catálogos."
      );
    }
  };

  // =========================================================
  // CARGA INICIAL
  // =========================================================

  useEffect(() => {
    getData();
  }, [
    users?.emp_id,
    flag,
  ]);

  useEffect(() => {
    getCatalogos();
  }, [users?.emp_id]);

  // =========================================================
  // ITEMS ORDENADOS
  // =========================================================

  const itemsOrdenados =
    useMemo(() => {
      return [...leer].sort(
        (a, b) =>
          String(
            a.nombre || ""
          ).localeCompare(
            String(
              b.nombre || ""
            ),
            "es"
          )
      );
    }, [leer]);

  // =========================================================
  // FILTRO
  // =========================================================

  const filteredItems =
    useMemo(() => {
      const q = (
        buscador || ""
      )
        .trim()
        .toLowerCase();

      return itemsOrdenados.filter(
        (it) => {
          const coincideCategoria =
            !categoria ||
            it.categoria ===
              categoria;

          const coincideBusqueda =
            !q ||
            Object.keys(
              it
            ).some((key) =>
              toSearchText(
                it[key]
              )
                .toLowerCase()
                .includes(q)
            );

          return (
            coincideCategoria &&
            coincideBusqueda
          );
        }
      );
    }, [
      buscador,
      categoria,
      itemsOrdenados,
    ]);

  // =========================================================
  // OPCIONES
  // =========================================================

  const categoriaOptions =
    useMemo(
      () =>
        categorias.map(
          (d, idx) => ({
            key:
              d.key ??
              d.id ??
              idx,

            text:
              d.text ||
              d.value,

            value:
              d.value ||
              d.text,
          })
        ),
      [categorias]
    );

  const medidaOptions =
    useMemo(
      () =>
        medidas.map(
          (d, idx) => ({
            key:
              d.key ??
              d.id ??
              idx,

            text:
              d.text ||
              d.value,

            value:
              d.value ||
              d.text,
          })
        ),
      [medidas]
    );

  // =========================================================
  // CAMBIO DE CATEGORÍA
  // =========================================================

  const cambiarCategoria = (
    e,
    { value }
  ) => {
    resetAlert();

    setCategoria(value);

    if (value !== "MEDICION") {
      setMedida("");
      setInicial("");
      setFinal("");
    }
  };

  // =========================================================
  // GUARDAR ITEM
  // =========================================================

  const handleSubmit = async (
    e
  ) => {
    e.preventDefault();

    if (guardando) return;

    resetAlert();

    if (!users?.emp_id) {
      return showError(
        "No se encontró emp_id del usuario."
      );
    }

    const it = norm(item);

    if (
      !categoria ||
      categoria ===
        "Selecciona Opción:"
    ) {
      return showError(
        "Seleccione una categoría."
      );
    }

    if (!it) {
      return showError(
        "No ha ingresado un Item."
      );
    }

    const noExiste =
      itemsOrdenados.filter(
        (x) =>
          norm(x.nombre) === it
      ).length === 0;

    if (!noExiste) {
      return showError(
        "Ya existe este Item."
      );
    }

    if (
      categoria === "MEDICION"
    ) {
      if (!medida) {
        return showError(
          "Ingrese una Unidad de Medida."
        );
      }

      if (
        inicial === "" ||
        inicial === null
      ) {
        return showError(
          "Ingrese un valor mínimo."
        );
      }

      if (
        final === "" ||
        final === null
      ) {
        return showError(
          "Ingrese un valor máximo."
        );
      }

      const valorInicial =
        Number(inicial);

      const valorFinal =
        Number(final);

      if (
        !Number.isFinite(
          valorInicial
        ) ||
        !Number.isFinite(
          valorFinal
        )
      ) {
        return showError(
          "Ingrese valores mínimo y máximo válidos."
        );
      }

      if (
        valorInicial >
        valorFinal
      ) {
        return showError(
          "El valor mínimo no puede ser mayor que el máximo."
        );
      }
    }

    setGuardando(true);

    try {
      const fechaOperacion =
        new Date();

      if (
        categoria ===
        "MEDICION"
      ) {
        await AgregarItemsDb({
          nombre: it,
          categoria,
          medida,
          inicial:
            parseFloat(
              inicial
            ),
          final:
            parseFloat(
              final
            ),
          userAdd:
            user?.email || "",
          userMod:
            user?.email || "",
          fechaAdd:
            fechaOperacion,
          fechaMod:
            fechaOperacion,
          emp_id:
            users.emp_id,
        });

        setMedida("");
        setInicial("");
        setFinal("");
      } else {
        await AgregarItemsDb({
          nombre: it,
          categoria,
          inicial: 0,
          final: 0,
          medida: "",
          userAdd:
            user?.email || "",
          userMod:
            user?.email || "",
          fechaAdd:
            fechaOperacion,
          fechaMod:
            fechaOperacion,
          emp_id:
            users.emp_id,
        });
      }

      showSuccess(
        "Item ingresado correctamente."
      );

      setItem("");

      setFlag(
        (f) => !f
      );
    } catch (error) {
      console.error(
        "Error al ingresar Item:",
        error
      );

      showError(
        error?.message ||
          "No fue posible ingresar el Item."
      );
    } finally {
      setGuardando(false);
    }
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <Container
      fluid
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        padding:
          "24px 12px 40px",
      }}
    >
      <Container
        fluid
        style={{
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        {/* CABECERA */}

        <Segment
          style={{
            border:
              "1px solid #e2e8f0",
            borderRadius: 12,
            boxShadow:
              "0 4px 14px rgba(15,23,42,.05)",
            padding:
              "18px 20px",
            marginBottom: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems:
                "center",
              gap: 14,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 10,
                background:
                  "#ecfdf5",
                display: "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
              }}
            >
              <Icon
                name="clipboard outline"
                color="teal"
                size="large"
                style={{
                  margin: 0,
                }}
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 220,
              }}
            >
              <Header
                as="h2"
                style={{
                  margin: 0,
                  color:
                    "#0f172a",
                }}
              >
                Ítems de Protocolo

                <Header.Subheader
                  style={{
                    marginTop: 5,
                  }}
                >
                  Administra los
                  ítems utilizados
                  para construir los
                  protocolos.
                </Header.Subheader>
              </Header>
            </div>

            <Button
              basic
              type="button"
              onClick={volver}
              disabled={
                guardando
              }
            >
              <Icon name="arrow left" />
              Volver
            </Button>
          </div>
        </Segment>

        {/* ===================================================
            1. NUEVO ITEM
        =================================================== */}

        <Segment
          style={{
            border:
              "2px solid #00b5ad",
            borderRadius: 12,
            boxShadow:
              "0 0 0 1px rgba(0,181,173,.08), 0 4px 14px rgba(15,23,42,.05)",
            marginBottom: 16,
          }}
        >
          <Header
            as="h3"
            style={{
              color: "#0f172a",
              marginBottom: 18,
            }}
          >
            <Icon
              name="plus square outline"
              color="teal"
            />

            <Header.Content>
              1. Nuevo Ítem de
              Protocolo

              <Header.Subheader>
                Crea un elemento que
                posteriormente podrá
                incorporarse a un
                protocolo.
              </Header.Subheader>
            </Header.Content>
          </Header>

          <Form
            onSubmit={
              handleSubmit
            }
            size="small"
          >
            <Form.Group
              widths="equal"
              style={{
                alignItems:
                  "flex-end",
              }}
            >
              <Form.Field>
                <label>
                  Categoría
                </label>

                <Dropdown
                  fluid
                  selection
                  search
                  placeholder="Selecciona categoría"
                  options={
                    categoriaOptions
                  }
                  value={
                    categoria ||
                    ""
                  }
                  onChange={
                    cambiarCategoria
                  }
                  disabled={
                    guardando
                  }
                />
              </Form.Field>

              <Form.Field>
                <label>
                  Nombre del ítem
                </label>

                <Input
                  fluid
                  placeholder="Ingrese Item"
                  value={item}
                  onChange={(e) =>
                    setItem(
                      e.target
                        .value
                    )
                  }
                  icon={{
                    name: "tag",
                    color: "teal",
                  }}
                  iconPosition="left"
                  disabled={
                    guardando
                  }
                />
              </Form.Field>
            </Form.Group>

            {/* MEDICIÓN */}

            {categoria ===
              "MEDICION" && (
              <Segment
                secondary
                style={{
                  marginTop: 8,
                  borderRadius: 8,
                  border:
                    "1px solid #e2e8f0",
                }}
              >
                <Header
                  as="h4"
                  style={{
                    color:
                      "#0f172a",
                  }}
                >
                  <Icon
                    name="sliders horizontal"
                    color="teal"
                  />

                  <Header.Content>
                    Configuración de
                    medición

                    <Header.Subheader>
                      Define la unidad y
                      el rango permitido
                      para este ítem.
                    </Header.Subheader>
                  </Header.Content>
                </Header>

                <Form.Group
                  widths="equal"
                >
                  <Form.Field>
                    <label>
                      Unidad de Medida
                    </label>

                    <Dropdown
                      fluid
                      selection
                      search
                      placeholder="Selecciona unidad"
                      options={
                        medidaOptions
                      }
                      value={
                        medida ||
                        ""
                      }
                      onChange={(
                        e,
                        { value }
                      ) =>
                        setMedida(
                          value
                        )
                      }
                      disabled={
                        guardando
                      }
                    />
                  </Form.Field>

                  <Form.Field>
                    <label>
                      Mínimo
                    </label>

                    <Input
                      fluid
                      type="number"
                      step="any"
                      value={
                        inicial
                      }
                      placeholder="Valor mínimo"
                      onChange={(e) =>
                        setInicial(
                          e.target
                            .value
                        )
                      }
                      icon={{
                        name:
                          "arrow down",
                        color:
                          "teal",
                      }}
                      iconPosition="left"
                      disabled={
                        guardando
                      }
                    />
                  </Form.Field>

                  <Form.Field>
                    <label>
                      Máximo
                    </label>

                    <Input
                      fluid
                      type="number"
                      step="any"
                      value={final}
                      placeholder="Valor máximo"
                      onChange={(e) =>
                        setFinal(
                          e.target
                            .value
                        )
                      }
                      icon={{
                        name:
                          "arrow up",
                        color:
                          "teal",
                      }}
                      iconPosition="left"
                      disabled={
                        guardando
                      }
                    />
                  </Form.Field>
                </Form.Group>
              </Segment>
            )}

            <div
              style={{
                display: "flex",
                justifyContent:
                  "flex-end",
                marginTop: 14,
              }}
            >
              <Button
                color="teal"
                type="submit"
                loading={
                  guardando
                }
                disabled={
                  guardando
                }
              >
                <Icon name="plus" />
                Agregar ítem
              </Button>
            </div>
          </Form>
        </Segment>

        {/* ===================================================
            2. LISTADO
        =================================================== */}

        <Segment
          style={{
            border:
              "1px solid #e2e8f0",
            borderRadius: 12,
            boxShadow:
              "0 4px 14px rgba(15,23,42,.05)",
            padding: 0,
            overflow: "hidden",
          }}
        >
          {/* CABECERA LISTADO */}

          <div
            style={{
              padding: 16,
              borderBottom:
                "1px solid #e2e8f0",
              display: "flex",
              alignItems:
                "center",
              justifyContent:
                "space-between",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <Header
              as="h3"
              style={{
                margin: 0,
                color:
                  "#0f172a",
              }}
            >
              <Icon
                name="list alternate outline"
                color="teal"
              />

              <Header.Content>
                2. Ítems
                registrados

                <Header.Subheader>
                  Catálogo disponible
                  para construir los
                  protocolos.
                </Header.Subheader>
              </Header.Content>
            </Header>

            <Label
              basic
              color="teal"
            >
              Registros
              <Label.Detail>
                {
                  filteredItems.length
                }
              </Label.Detail>
            </Label>
          </div>

          {/* BUSCADOR */}

          <div
            style={{
              padding:
                "14px 16px",
              borderBottom:
                "1px solid #e2e8f0",
              background: "#fff",
            }}
          >
            <Input
              fluid
              placeholder="Buscar por ítem, categoría, unidad u otro dato..."
              value={
                buscador
              }
              onChange={(e) =>
                setBuscador(
                  e.target
                    .value
                )
              }
              icon={{
                name: "search",
                color: "teal",
              }}
            />
          </div>

          {/* TABLA */}

          <div
            style={{
              overflow: "auto",
              maxHeight: 520,
            }}
          >
            <Table
              celled
              striped
              selectable
              compact="very"
              style={{
                margin: 0,
                minWidth: 900,
                fontSize: 12,
              }}
            >
              <Table.Header
                style={{
                  position:
                    "sticky",
                  top: 0,
                  zIndex: 2,
                  background:
                    "#f8fafc",
                }}
              >
                <Table.Row>
                  <Table.HeaderCell
                    width={1}
                    textAlign="center"
                  >
                    #
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Ítem
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Categoría
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Unidad
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    textAlign="right"
                  >
                    Mínimo
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    textAlign="right"
                  >
                    Máximo
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Agregado por
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {filteredItems.map(
                  (
                    it,
                    index
                  ) => (
                    <Table.Row
                      key={
                        it.id ??
                        index
                      }
                    >
                      <Table.Cell
                        textAlign="center"
                      >
                        {index +
                          1}
                      </Table.Cell>

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "normal",
                          wordWrap:
                            "break-word",
                          fontWeight:
                            600,
                        }}
                      >
                        {
                          it.nombre
                        }
                      </Table.Cell>

                      <Table.Cell>
                        <Label
                          basic
                          size="tiny"
                          color="teal"
                        >
                          {
                            it.categoria
                          }
                        </Label>
                      </Table.Cell>

                      <Table.Cell>
                        {it.medida ||
                          "—"}
                      </Table.Cell>

                      <Table.Cell
                        textAlign="right"
                      >
                        {it.categoria ===
                        "MEDICION"
                          ? it.inicial
                          : "—"}
                      </Table.Cell>

                      <Table.Cell
                        textAlign="right"
                      >
                        {it.categoria ===
                        "MEDICION"
                          ? it.final
                          : "—"}
                      </Table.Cell>

                      <Table.Cell>
                        {it.useradd ||
                          "—"}
                      </Table.Cell>
                    </Table.Row>
                  )
                )}

                {filteredItems.length ===
                  0 && (
                  <Table.Row>
                    <Table.Cell
                      colSpan="7"
                      textAlign="center"
                      style={{
                        padding: 35,
                        color:
                          "#64748b",
                      }}
                    >
                      <Icon
                        name="inbox"
                        size="large"
                        color="grey"
                      />

                      <div
                        style={{
                          marginTop: 8,
                        }}
                      >
                        {buscador
                          ? "Sin resultados para la búsqueda."
                          : categoria
                            ? `No hay items de ${categoria}.`
                            : "No hay items para mostrar."}
                      </div>
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </div>
        </Segment>

        {/* ALERTAS */}

        <Alertas
          tipo={
            alerta.tipo
          }
          mensaje={
            alerta.mensaje
          }
          estadoAlerta={
            estadoAlerta
          }
          cambiarEstadoAlerta={
            cambiarEstadoAlerta
          }
        />
      </Container>
    </Container>
  );
};

export default AgregarItems;